import { render, staticRenderFns } from "./Monthly-report.vue?vue&type=template&id=66af7302"
import script from "./Monthly-report.vue?vue&type=script&lang=ts"
export * from "./Monthly-report.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports